module.exports = __webpack_public_path__ + "static/img/testBg.3651de1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/devops/testBg.png
// module id = J+bf
// module chunks = 3